import React from 'react';
import { NavLink } from 'react-router-dom';
import { Menu, Dropdown } from 'antd';
import {
  SearchOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  QuestionOutlined,
  PercentageOutlined
} from '@ant-design/icons';
import AccountMenu from '../AccountMenu';

interface RightMenuListProps {
  deviceType: String;
}

const RightMenuList: React.FC<RightMenuListProps> = (Props) => {
  return (
    <div className="right-menu">
      <Menu theme="dark" mode="horizontal">
        <Menu.Item key="1">
          <NavLink to="/search">
            <SearchOutlined />
            Search
          </NavLink>
        </Menu.Item>
        <Menu.Item key="2">
          <NavLink to="/offers">
            <PercentageOutlined />
            Offers
          </NavLink>
        </Menu.Item>
        <Menu.Item key="3">
          <NavLink to="/help">
            <QuestionOutlined />
            Help
          </NavLink>
        </Menu.Item>
        <Menu.Item key="4">
          <Dropdown overlay={AccountMenu} placement="bottomCenter" arrow>
            <span>
              <UserOutlined />
              Account
            </span>
          </Dropdown>
        </Menu.Item>
        <Menu.Item key="5">
          <NavLink to="/cart">
            <ShoppingCartOutlined />
            Cart
          </NavLink>
        </Menu.Item>
      </Menu>
    </div>
  );
};

export default RightMenuList;
